import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin } from 'lucide-react';
import { useSiteData } from '../../context/SiteDataContext';

const Footer = () => {
  const { companyInfo } = useSiteData();

  return (
    <footer className="bg-black text-white border-t border-white/10">
      <div className="max-w-6xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Logo & Description */}
          <div className="lg:col-span-1">
            <img
              src={companyInfo.logo}
              alt={companyInfo.name}
              className="h-16 w-auto mb-6"
            />
            <p className="text-white/50 text-sm leading-relaxed">
              Expert en reprogrammation moteur et pose de films solaires à Eugénie les Bains.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-white/80 mb-6">Navigation</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/" className="text-white/50 hover:text-white transition-colors">Accueil</Link></li>
              <li><Link to="/reprogrammation" className="text-white/50 hover:text-white transition-colors">Reprogrammation</Link></li>
              <li><Link to="/films-solaires" className="text-white/50 hover:text-white transition-colors">Films Solaires</Link></li>
              <li><Link to="/contact" className="text-white/50 hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-white/80 mb-6">Services</h4>
            <ul className="space-y-3 text-sm text-white/50">
              <li>Stage 1 & Stage 2</li>
              <li>Conversion E85</li>
              <li>Solutions AdBlue / EGR / FAP</li>
              <li>Films Solaires</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-white/80 mb-6">Contact</h4>
            <div className="space-y-4 text-sm">
              <div className="flex items-start gap-3 text-white/50">
                <MapPin size={18} className="mt-0.5 flex-shrink-0 text-red-500" />
                <span>{companyInfo.address}<br />{companyInfo.city}</span>
              </div>
              <div className="flex items-center gap-3">
                <Phone size={18} className="flex-shrink-0 text-red-500" />
                <a href={`tel:${companyInfo.phone.replace(/\s/g, '')}`} className="text-white/50 hover:text-white transition-colors">
                  {companyInfo.phone}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Copyright */}
      <div className="border-t border-white/5">
        <div className="max-w-6xl mx-auto px-6 lg:px-12 py-6">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-white/30 text-sm text-center">
            <span>© {new Date().getFullYear()} {companyInfo.name}. Tous droits réservés.</span>
            <span className="hidden sm:inline">·</span>
            <Link to="/cgv" className="hover:text-white/60 transition-colors underline underline-offset-2" data-testid="footer-cgv-link">
              Conditions Générales de Vente
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
